import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { EditorElementBuilder } from '@wix/component-protocol/builder';
import { ActionType, PanelContentType, PanelSizeWidth, PanelType, DefaultBehaviors, DefaultLayout } from '@wix/editor-platform-ooi-metadata-resolver';
import { mapOOISettingsToManifestData, mapOOIStylesToManifestStyles, mapOOIPresetsToManifestPresets, mapOOIGroupingsToManifestDisplayGroups } from '@wix/editor-platform-ooi-metadata-resolver/mappers';
var _displayName = /*#__PURE__*/new WeakMap();
var _styleParams = /*#__PURE__*/new WeakMap();
var _settingParams = /*#__PURE__*/new WeakMap();
var _dashboardAction = /*#__PURE__*/new WeakMap();
var _settingsAction = /*#__PURE__*/new WeakMap();
var _customActions = /*#__PURE__*/new WeakMap();
var _nativeSettingsPanelUrl = /*#__PURE__*/new WeakMap();
var _innerElements = /*#__PURE__*/new WeakMap();
var _displayFilters = /*#__PURE__*/new WeakMap();
var _presets = /*#__PURE__*/new WeakMap();
var _displayGroups = /*#__PURE__*/new WeakMap();
var _layout = /*#__PURE__*/new WeakMap();
var _OOIManifestBuilder_brand = /*#__PURE__*/new WeakSet();
export class OOIManifestBuilder {
  constructor(_ref) {
    let {
      statics: options,
      nativeSettingsPanelUrl,
      layout
    } = _ref;
    _classPrivateMethodInitSpec(this, _OOIManifestBuilder_brand);
    _defineProperty(this, "builder", void 0);
    _classPrivateFieldInitSpec(this, _displayName, void 0);
    _classPrivateFieldInitSpec(this, _styleParams, void 0);
    _classPrivateFieldInitSpec(this, _settingParams, void 0);
    _classPrivateFieldInitSpec(this, _dashboardAction, void 0);
    _classPrivateFieldInitSpec(this, _settingsAction, void 0);
    _classPrivateFieldInitSpec(this, _customActions, void 0);
    _classPrivateFieldInitSpec(this, _nativeSettingsPanelUrl, void 0);
    _classPrivateFieldInitSpec(this, _innerElements, void 0);
    _classPrivateFieldInitSpec(this, _displayFilters, void 0);
    _classPrivateFieldInitSpec(this, _presets, void 0);
    _classPrivateFieldInitSpec(this, _displayGroups, void 0);
    _classPrivateFieldInitSpec(this, _layout, void 0);
    this.builder = new EditorElementBuilder();
    _classPrivateFieldSet(_displayName, this, options.displayName);
    _classPrivateFieldSet(_styleParams, this, options.styleParams);
    _classPrivateFieldSet(_settingParams, this, options.settingsParams);
    _classPrivateFieldSet(_dashboardAction, this, options.dashboardAction);
    _classPrivateFieldSet(_settingsAction, this, options.settingsAction);
    _classPrivateFieldSet(_customActions, this, options.customActions);
    _classPrivateFieldSet(_innerElements, this, options.innerElements ?? []);
    _classPrivateFieldSet(_displayFilters, this, options.displayFilters);
    _classPrivateFieldSet(_presets, this, options.presetsPanel);
    _classPrivateFieldSet(_displayGroups, this, options.groupings);
    _classPrivateFieldSet(_nativeSettingsPanelUrl, this, nativeSettingsPanelUrl);
    _classPrivateFieldSet(_layout, this, layout);
  }
  configure(fn) {
    fn(this.builder);
    return this;
  }

  // when isMobile in not passed, we will create a style/data
  // params without default values to persist it in store
  build(options) {
    const paramsData = Object.fromEntries(_classPrivateFieldGet(_innerElements, this).flatMap(_ref2 => {
      let {
        elementParams
      } = _ref2;
      return elementParams || [];
    }).filter(param => param.displayName).map(param => [param.key, param]));
    const mapperOptions = {
      isMobile: options == null ? void 0 : options.isMobile,
      paramsData
    };
    const mappedStyleItems = _classPrivateFieldGet(_styleParams, this) ? mapOOIStylesToManifestStyles(_classPrivateFieldGet(_styleParams, this), mapperOptions) : {};
    const mappedDataItems = _classPrivateFieldGet(_settingParams, this) ? mapOOISettingsToManifestData(_classPrivateFieldGet(_settingParams, this), mapperOptions) : {};
    const mappedPresets = _classPrivateFieldGet(_presets, this) ? mapOOIPresetsToManifestPresets(_classPrivateFieldGet(_presets, this)) : {};
    const mappedDisplayGroups = _classPrivateFieldGet(_displayGroups, this) ? mapOOIGroupingsToManifestDisplayGroups(_classPrivateFieldGet(_displayGroups, this)) : {};
    _classPrivateFieldGet(_innerElements, this).forEach(innerElement => {
      const data = {};
      const style = {};
      for (const param of innerElement.elementParams ?? []) {
        const key = param.key;
        if (key in mappedStyleItems) {
          // @ts-expect-error - TODO: mappers provide mismatched types, remove this once the mappers are fixed
          style[key] = Object.assign(param.displayName ? {
            displayName: param.displayName
          } : {}, mappedStyleItems[key]);

          // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
          delete mappedStyleItems[key];
        } else {
          data[key] = Object.assign(param.displayName ? {
            displayName: param.displayName
          } : {}, mappedDataItems[key]);

          // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
          delete mappedDataItems[key];
        }
      }
      this.builder.setInlineElement(innerElement.id, {
        displayName: innerElement.displayName,
        data,
        cssCustomProperties: style,
        behaviors: DefaultBehaviors
      });
    });
    if (Object.keys(mappedStyleItems).length) {
      // @ts-expect-error - TODO: mappers provide mismatched types, remove this once the mappers are fixed
      this.builder.setCssCustomProperties(mappedStyleItems);
    }
    if (Object.keys(mappedDataItems).length) {
      this.builder.setData(mappedDataItems);
    }
    if (Object.keys(mappedPresets).length) {
      this.builder.setPresets(mappedPresets);
    }
    if (Object.keys(mappedDisplayGroups).length) {
      this.builder.setDisplayGroups(mappedDisplayGroups);
    }
    if (_classPrivateFieldGet(_dashboardAction, this)) {
      this.builder.setAction('dashboard', _classPrivateFieldGet(_dashboardAction, this));
    }
    if (_classPrivateFieldGet(_nativeSettingsPanelUrl, this)) {
      var _classPrivateFieldGet2;
      this.builder.setAction('settings', {
        displayName: (_classPrivateFieldGet2 = _classPrivateFieldGet(_settingsAction, this)) == null ? void 0 : _classPrivateFieldGet2.displayName,
        execution: {
          actionType: ActionType.panel,
          panel: {
            panelType: PanelType.inline,
            inline: {
              contentType: PanelContentType.url,
              url: _classPrivateFieldGet(_nativeSettingsPanelUrl, this),
              size: {
                width: PanelSizeWidth.MEDIUM,
                height: 528
              }
            }
          }
        }
      });
    }
    this.builder.setLayout(_classPrivateFieldGet(_layout, this) || DefaultLayout);
    if (_classPrivateFieldGet(_displayName, this)) {
      this.builder.setDisplayName(_classPrivateFieldGet(_displayName, this));
    }
    if (_classPrivateFieldGet(_displayFilters, this)) {
      this.builder.setDisplayFilters(_classPrivateFieldGet(_displayFilters, this));
    }
    _classPrivateFieldGet(_customActions, this) && this.builder.setCustomActions(_assertClassBrand(_OOIManifestBuilder_brand, this, _applyCustomActionDefinitionFixer).call(this, _classPrivateFieldGet(_customActions, this)));
    const manifest = this.builder.build();
    return {
      editorElement: manifest
    };
  }
}
function _applyCustomActionDefinitionFixer(customActions) {
  const customActionsEntries = Object.entries(customActions).map(_ref3 => {
    let [id, definition] = _ref3;
    return [id, {
      ...definition,
      execution: {
        ...definition.execution,
        actionType: definition.execution.actionType || _assertClassBrand(_OOIManifestBuilder_brand, this, _getCustomActionType).call(this, definition.execution)
      }
    }];
  });
  return Object.fromEntries(customActionsEntries);
}
function _getCustomActionType(execution) {
  if ('data' in execution) {
    return ActionType.data;
  }
  if ('event' in execution) {
    return ActionType.event;
  }
  if ('forward' in execution) {
    return ActionType.forward;
  }
  if ('panel' in execution) {
    return ActionType.panel;
  }
  if ('style' in execution) {
    return ActionType.style;
  }
  return ActionType.UNKNOWN_ActionType;
}
//# sourceMappingURL=ooi-manifest-builder.js.map